<div class="tooltip">
    <div>
        <i *ngIf="!iconSVG"
            class="material-icons tooltip"
            attr.aria-labelledby="{{randomUUIDForHeader}} {{randomUUIDForBody}}">
                {{icon}}
        </i>
        <img *ngIf="iconSVG"
            src="assets/image/{{icon}}"
            alt=""
            attr.aria-labelledby="{{randomUUIDForHeader}} {{randomUUIDForBody}}">
        <homefield-icon
            class="hyperlink info-icon hmf-display-inline-flex"
            width="18px"
            height="18px"
            name="{{hmfIcon}}"
            fill="var(--hmf-gray700)">
        </homefield-icon>
    </div>
    <span class="tooltiptext showOnHover">
            <div>
                    <b *ngIf="textHeader"
                        [id]="randomUUIDForHeader">
                            {{textHeader}}
                    </b>
                    <br *ngIf="textHeader">
                    <p
                        [id]="randomUUIDForBody"
                        [innerHtml]="textBody | bypassSanitization">
                    </p>
            </div>
    </span>
</div>
